import React, { useState, useEffect,lazy } from 'react'
import { Pane, Text } from "evergreen-ui"
import * as Sentry from "@sentry/react";
import { Routes, Route, Link, useNavigate, Navigate } from "react-router-dom";

import './App.scss'
import { Quote } from './Quote'
import { useLibrary, Library } from './Library';
import { Cart as CartView, BookOrder, useCart } from './Cart';

import { useAPI } from './Api';

import { Review } from './Cart/Review'
// import { SignUp } from './SignUp/SignUp';
import { LogIn } from './SignUp/LogIn';
import { Loading, useMatchMedia } from './Misc'


// import { DXFTest } from './DXFTest';
//import { Admin } from './Admin';
 import { Orders } from './Orders';

//
import { AppFrame } from './AppFrame';
import { ErrorOrder } from './ErrorOrder';

const Admin = lazy(() => import("./Admin"));
const DXFTest = lazy(() => import("./DXFTest"));
const LibraryList = lazy(() => import("./LibraryList"));
// const Orders = lazy(() => import("./Orders"));
const SignUp = lazy(() => import("./SignUp/SignUp"));

export let SideButton = (props) => {
  return <Pane
    cursor={"pointer"}
    borderRadius={4}
    elevation={props.elevation || (props.selected ? 3 : 1)}
    width={props.width || 150}
    height={props.height || 40}
    margin={4}
    alignItems="center"
    justifyContent="left"
    display="flex"
    padding={16}
    background={props.background}
    color={props.color || "black"}
    onClick={() => { props.onClick && props.onClick() }}
  ><span style={{ fontWeight: 'bolder', fontSize: 'large', width: '100%' }}>
      {props.children}
    </span>
  </Pane>;
}

export function App(props) {
  let navigate = useNavigate();
  let API = useAPI();
  let Cart = useCart();
  let theLibrary = useLibrary();
  const [selectedFolder, setSelectedFolder] = React.useState(null);
  const [order, setOrder] = React.useState(null);
  const [errorOrder, setErrorOrder] = React.useState(false);

  let newOrder = (book) => {
    if (book) {
      let boorder = new BookOrder(book);
      console.log('boorder.drawing.errors', boorder)
      setErrorOrder(boorder.drawing.errors && (boorder.drawing.errors.length > 0))
      setOrder(boorder);
    }
  }

  let selectOrder = (key) => {
    if (Cart.cartItems)
      setOrder(Cart.cartItems.filter(v => v.key == key).pop());
  }




  React.useEffect(() => {
    if (API.isAuth()) {
      if (!theLibrary.items) {
        theLibrary.reloadLibrary();
      }
    }
  }, [API.auth]);


  React.useEffect(() => {
    if (!order){
      setErrorOrder(false)
    }
    if (order && Cart.cartItems){
      Cart.update(order)
    }
  }, [order]);


  const isDesktopResolution = useMatchMedia('(min-width:992px)', true)


  const SentryRoutes = Routes;//Sentry.withSentryReactRouterV6Routing(Routes)

  let isAuth = API.isAuth();

  return <AppFrame isAdmin={API.isAdmin} isAuth={API.isAuth()} setOrder={setOrder}>
    <Pane flex={3} style={{ minHeight: "100%", maxHeight: "100%", overflow: 'scroll', background: '#f1f1f1' }} >
    <React.Suspense fallback="Loading...">
      <SentryRoutes>
        <Route path="signup" element={<SignUp />} />
        <Route path="login" element={<LogIn />} />
        {isAuth &&
          <>
            <Route path="cart" element={<Review onSelectOrder={(key) => {
              navigate('/projects')
              selectOrder(key)
            }} setOrder={setOrder} />} />
            <Route path="projects" element={
              <Pane className="main" display={'flex'} style={{
                position: 'absolute',
                top: '60px',
                left: 0,
                right: 0,
                bottom: 0,
                overflow: 'hidden',
              }}>
                {(!theLibrary.items) ? <Loading {...theLibrary.loading}>
                  <Text><h1>Loading Project Files...</h1></Text>
                </Loading> :

                  <>
                    {(!order || errorOrder) && <Library onAddNewOrder={newOrder} setSelectedFolder={setSelectedFolder} selectedFolder={selectedFolder} />}
                    {order && !errorOrder && <Quote
                      key={order.key} order={order} setOrder={setOrder}
                      onClose={(c) => { setOrder(null) }} />}
                    {order && errorOrder && <ErrorOrder key={order.key} order={order}
                      onClose={() => {
                        setErrorOrder(false);
                        setOrder(null);
                      }} />}
                  </>}

                {isDesktopResolution &&
                  <CartView onSelectOrder={(key) => {
                    navigate('/projects')
                    selectOrder(key)
                  }} />}
              </Pane>
            }


            />
            <Route path="DXFTest" element={<DXFTest />} />
            <Route path="LibraryList" element={<LibraryList />} />
            <Route path="orders" element={<Orders />} />
            <Route path="admin" element={<Admin />} />
          </>}

        <Route
          path="*"
          element={API.isAuth() == false ? <LogIn /> : <Navigate to="/projects" />} />
      </SentryRoutes>
      </React.Suspense>
    </Pane>

  </AppFrame>


} 